import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "../components/ui/accordion";
import { FAQS } from "../lib/constants";
import { WarrantyTable } from "../components/WarrantyTable";

export const FAQ = () => {
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="relative py-16 sm:py-24 lg:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8">
        {/* Warranty reference table */}
        <div className="mb-12 sm:mb-16">
          <div className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500 mb-4">
            [ Verified warranty reference ]
          </div>
          <h2 className="font-display text-2xl sm:text-4xl lg:text-5xl font-semibold leading-[1] text-white mb-6">
            Your warranty,
            <br />
            <span className="brand-text-gradient">by model.</span>
          </h2>
          <WarrantyTable />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 sm:gap-12 pt-12 sm:pt-16 border-t border-white/5">
          <div className="lg:col-span-5">
            <div className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500 mb-4">
              [ 08 — Questions ]
            </div>
            <h2 className="font-display text-3xl sm:text-5xl font-semibold leading-[1] text-white">
              Frequently
              <br />
              <span className="brand-text-gradient">asked.</span>
            </h2>
            <p className="text-zinc-400 mt-6 leading-relaxed max-w-md">
              Can't find what you need? Email{" "}
              <a
                href="mailto:support@eviq.pro"
                className="text-white underline underline-offset-4 hover:text-[#39FF14] transition-colors"
                data-testid="faq-email-link"
              >
                support@eviq.pro
              </a>{" "}
              and we'll get back within a day.
            </p>
          </div>

          <div className="lg:col-span-7">
            <Accordion
              type="single"
              collapsible
              className="w-full"
              data-testid="faq-accordion"
            >
              {FAQS.map((f, i) => (
                <AccordionItem
                  key={i}
                  value={`item-${i}`}
                  className="border-white/10"
                  data-testid={`faq-item-${i}`}
                >
                  <AccordionTrigger className="text-left text-white text-base lg:text-lg font-medium hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent className="text-zinc-400 leading-relaxed text-[15px]">
                    {f.a}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </div>

        {/* Referral program rules — official terms, bottom of FAQ */}
        <div
          className="mt-12 sm:mt-16 pt-10 border-t border-white/5"
          data-testid="referral-rules"
        >
          <div className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500 mb-4">
            [ Referral program rules ]
          </div>
          <h3 className="text-base md:text-lg text-white font-semibold mb-5">
            Refer a friend, earn free months — here's exactly how it works.
          </h3>
          <ul className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-3 max-w-4xl">
            {[
              "You must have an active paid EVIQ subscription to earn referral rewards.",
              "Each qualifying referral — a friend who subscribes through your personal link — earns you 1 free month, applied as a $9.99 credit to your next invoice.",
              "Limit 1 free month per quarter (90 days), and no more than 4 free months per year.",
              "Referrals beyond the limit still count on your record and the public leaderboard — they just don't add a credit.",
              "Self-referrals, duplicate accounts, and canceled subscriptions don't qualify for credits.",
              "EVIQ may adjust or revoke rewards in cases of abuse. Credits have no cash value and apply to future invoices only.",
            ].map((rule, i) => (
              <li key={i} className="flex items-start gap-2.5 text-zinc-400 text-sm leading-relaxed">
                <span className="font-mono text-[10px] text-[#39FF14] mt-1 shrink-0">{String(i + 1).padStart(2, "0")}</span>
                {rule}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};
